<ngb-datepicker #dp navigation="arrows" [(ngModel)]="modelDate" [showWeekNumbers]="false" firstDayOfWeek="1"
    (dateSelect)="selectDate($event)" [ngClass]="classDate" [dayTemplate]="customDay">
</ngb-datepicker>
<ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled"
    let-focused="focused">
    <div class="btn-light custom-day-default" [class.focused]="focused" [class.bg-primary]="selected"
        [class.hidden]="date.month !== currentMonth" [class.text-white]="selected"
        [class.outside]="date.month !== currentMonth" [class.text-muted]="disabled || date.month !== currentMonth"
        [class.bg-holiday]="getNationalHoliday(date)">
        {{ date.day }}
    </div>
</ng-template>